import { gt, isEqual, lt, size } from 'lodash';

export const converNumericStringToPhoneNumberMaskString = (numericString: string) => {
  let maskedPhoneNumber = '';
  for (let index = 0; lt(index, size(numericString)); index++) {
    if (isEqual(index, 4) || (gt(index, 4) && isEqual((index - 1) % 3, 0))) {
      maskedPhoneNumber += ' ';
    }
    maskedPhoneNumber += numericString?.charAt(index);
  }

  return maskedPhoneNumber;
};
